import { render } from "./RegisterVerifyView.vue?vue&type=template&id=dbe6e8ec&scoped=true"
import script from "./RegisterVerifyView.vue?vue&type=script&lang=js"
export * from "./RegisterVerifyView.vue?vue&type=script&lang=js"

import "./RegisterVerifyView.vue?vue&type=style&index=0&id=dbe6e8ec&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe6e8ec"]])

export default __exports__